import * as React from 'react';

import {LinkedEntity} from '../../../linked-entity/linked-entity';

import {TruncatedItems} from './truncated-items';

type Props = {
    value: any[];
};

export function Entity(props: Props) {
    return (
        // @ts-expect-error
        <TruncatedItems
            isTokenized={false}
            value={props.value}
            renderRow={(entity) => {
                return (
                    <LinkedEntity
                        key={entity.id}
                        name={entity.name}
                        type={entity.type}
                        htmlUrl={entity.htmlUrl}
                        shouldClientRoute={true}
                        stopPropagation={true}
                    />
                );
            }}
        />
    );
}
